import { Route, Routes, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import './App.css'
import AnalysisDashboard from './pages/AnalysisDashboard'
import AnalysisResultsPage from './pages/AnalysisResultsPage'
import JobResultsPage from './pages/JobResultsPageNew'
import JobsPage from './pages/JobsPage'
import SignIn from './pages/SignIn'
import Header from './components/common/Header'
import UserDashboard from './pages/UserDashboard_Old'
import CallAnalysisPage from './pages/Analysis'
import MainDashboard from './pages/MainDashboard'
import SettingsPage from './pages/Settings'
import AuthGuard from './Provider/AuthGuard'
import ProtectedRoute from './components/common/ProtectedRoute'
import LandingPage from './pages/LandingPage'
import ThankYouPage from './pages/ThankYouPage'
import ChatBot from './components/common/ChatBot'
import PrivacyPolicy from './pages/PrivacyPolicy'
import TermsOfService from './pages/TermsOfService'
import CookiePolicy from './pages/CookiePolicy'
import { useTheme } from './zustand/ThemeStore'
import SupademoEmbed from './pages/Test'
import ExtensionRedirect from './pages/ExtensionRedirect'

function App() {
  const location = useLocation();
  const isDarkMode = useTheme((state) => state.theme);
  
  // Apply theme to body element
  useEffect(() => {
    if (isDarkMode) {
      document.body.classList.add('dark-theme');
      document.body.classList.remove('light-theme');
    } else {
      document.body.classList.add('light-theme');
      document.body.classList.remove('dark-theme');
    }
  }, [isDarkMode]);
  
  // Don't show chatbot on landing page, auth page, policy pages, and thank you page
  const showChatBot = !['/', '/auth', '/thank-you', '/privacy-policy', '/terms-of-service', '/cookie-policy', '/walkthrough', '/extension'].includes(location.pathname);

  return (
    <>
      <Routes>
        <Route path='/auth' element={<SignIn/>} />
        <Route path='/analysis-results/:resultId' element={
          <AuthGuard>
            <ProtectedRoute>
              <Header><AnalysisResultsPage/></Header>
            </ProtectedRoute>
          </AuthGuard>
        } />
        <Route path='/job-results/:jobId' element={
          <AuthGuard>
            <ProtectedRoute>
              <Header><JobResultsPage/></Header>
            </ProtectedRoute>
          </AuthGuard>
        } />
        <Route path='/jobs' element={
          <AuthGuard>
            <ProtectedRoute>
              <Header><JobsPage/></Header>
            </ProtectedRoute>
          </AuthGuard>
        } />
        <Route path='/analysis/:id' element={
          <AuthGuard>
            <ProtectedRoute>
              <Header><CallAnalysisPage/></Header>
            </ProtectedRoute>
          </AuthGuard>
        } />
        <Route path='/user/:userId' element={
          <AuthGuard>
            <ProtectedRoute requiredPermissions={{ canAccessUserDashboard: true }}>
              <Header><UserDashboard/></Header>
            </ProtectedRoute>
          </AuthGuard>
        } />
        <Route path='/analysis' element={
          <AuthGuard>
            <ProtectedRoute>
              <Header><AnalysisDashboard/></Header>
            </ProtectedRoute>
          </AuthGuard>
        } />
        <Route path='/settings' element={
          <AuthGuard>
            <ProtectedRoute requiredPermissions={{ canAccessSettings: true }}>
              <Header><SettingsPage/></Header>
            </ProtectedRoute>
          </AuthGuard>
        } />

        <Route path='/main' element={
          <AuthGuard>
            <ProtectedRoute requiredPermissions={{ canAccessMainDashboard: true }}>
              <Header><MainDashboard/></Header>
            </ProtectedRoute>
          </AuthGuard>
        } />
        <Route path='/' element={<LandingPage/>}></Route>
        <Route path='/extension' element={<ExtensionRedirect/>}></Route>
        <Route path='/walkthrough' element={<SupademoEmbed/>}></Route>
        <Route path='/thank-you' element={<ThankYouPage/>}></Route>
        <Route path='/privacy-policy' element={<PrivacyPolicy/>}></Route>
        <Route path='/terms-of-service' element={<TermsOfService/>}></Route>
        <Route path='/cookie-policy' element={<CookiePolicy/>}></Route>
      </Routes>
      
      {/* Show ChatBot on authenticated pages only */}
      {showChatBot && <ChatBot />}
    </>
  )
}

export default App
